import autosize from 'autosize' 

$(function () {

  autosize($('.js-textarea'));

})